import { render, staticRenderFns } from "./CreateStudent.vue?vue&type=template&id=174a4ac0&scoped=true&"
import script from "./CreateStudent.vue?vue&type=script&lang=js&"
export * from "./CreateStudent.vue?vue&type=script&lang=js&"
import style0 from "./CreateStudent.vue?vue&type=style&index=0&id=174a4ac0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174a4ac0",
  null
  
)

export default component.exports